/**
 * @todo rewrite in vanilla js
 */
export default function () {
  $(".accordion-title").click(function () {
    $(this).toggleClass("open");
    $(this).find(".accordion-body").slideToggle();
  });

  $(".accordionHeader").click(function () {
    $(this).toggleClass("clicked");
    let accordionBody = $(this).next();
    // accordionBody.toggleClass("open");
    accordionBody.slideToggle();
  });

  if ($("#open-video-accordion-by-language")) {
    let open_data_value = $("#open-video-accordion-by-language").data("language");
    let selected_accordion_item = $('.accordion-title[data-language="' + open_data_value +'"');
    console.log(selected_accordion_item);
    selected_accordion_item.toggleClass('open');
    selected_accordion_item.find('.accordion-body').slideToggle();
  }
}
